export const Navigation = {
    home: () => '/',
    eventsList: () => '/event/list'
};